/* Joint Genie listicle — countdown timer for the promo bar */
(function () {
  var root = document.querySelector('[data-jg7-timer]');
  if (!root) return;
  var h = root.querySelector('[data-jg7="h"]');
  var m = root.querySelector('[data-jg7="m"]');
  var s = root.querySelector('[data-jg7="s"]');
  if (!h || !m || !s) return;

  var hours = parseFloat(root.getAttribute('data-jg7-hours')) || 11;
  var K = 'jg7-deadline';
  var d = +localStorage.getItem(K);
  if (!d || d < Date.now()) {
    d = Date.now() + hours * 3600 * 1000;
    localStorage.setItem(K, d);
  }
  function pad(n) { return String(n).padStart(2, '0'); }
  function tick() {
    var r = Math.max(0, d - Date.now());
    var sec = Math.floor(r / 1000);
    h.textContent = pad(Math.floor(sec / 3600));
    m.textContent = pad(Math.floor((sec % 3600) / 60));
    s.textContent = pad(sec % 60);
  }
  tick();
  setInterval(tick, 1000);
})();
